import { ButtonLink, Logo } from "@rhema/ui";
import { useEffect, useState } from "react";

type Health = { status: string; version: string };

// Server health check, kept from Phase 0 for deploy checks.
export function StatusScreen() {
  const [health, setHealth] = useState<Health | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetch("/api/health")
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then(setHealth)
      .catch(() => setFailed(true));
  }, []);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 px-4 text-center">
      <Logo size={88} variant="tile" />
      <h1 className="font-serif text-4xl font-medium tracking-tight">Rhema</h1>
      <p className="max-w-sm text-ink-secondary">Private messages and calls for the people you know.</p>
      <p className="text-sm text-ink-meta" aria-live="polite">
        {health && `Server ${health.status}, version ${health.version}`}
        {failed && <span className="text-scarlet">The server could not be reached.</span>}
        {!health && !failed && "Checking the server"}
      </p>
      <ButtonLink href="/chats" variant="tonal">
        Open chats
      </ButtonLink>
    </main>
  );
}
